"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Backdrop.default;
  }
});

var _Backdrop = _interopRequireDefault(require("./Backdrop"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/Backdrop/index.js
 ** module id = 375
 ** module chunks = 0
 **/